import React, { useEffect, useState, useCallback, useContext } from "react";
import { toast } from "react-toastify";
import { Link, useHistory } from "react-router-dom";
import DefaultFacebookLeadAds from "./DefaultFacebookLeadAds";
import FacebookLeadAdsTable from "./FacebookLeadAdsTable";
import ConnectFacebookFormModal from "../../../../../components/Modals/ConnectFacebookFormModal";
import {
  getProjectFormIds,
  getAllApikeys,
  deleteProjectFormId,
  getAuthRolePermissions,
} from "../../../../../services/private/company.service";
import FbIntegrationModal from "../../../../../components/Modals/FbIntegrationModal";
import SearchIcon from '../../../../../assets/icons/search.svg';
import SmallCenterModal from "../../../../../components/Modals/small-center-modal";
import Consumer from '../../../../../helpers/context';
import { ReactComponent as Pageback } from '../../../../../assets/icons/Pageback.svg';


const FacebookLeadAds = () => {
  const [showConnectFacebookForm, setConnectFacebookForm] = useState(false);
  const [projectFormIDs, setProjectFormIDs] = useState([]);
  const [apiKey, setApiKey] = useState("");
  const [integrationPermission, setIntegrationPermission] = useState();
  const [selectedIntegration, setSelectedIntegration] = useState();
  const [showFbModal, setShowFbModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [showNewFBInfoModal, setShowNewFBInfoModal] = useState(false);
  const [newIntergrations, setNewIntegration] = useState(false);

  let { allowedPermissions, isRolesModule } = useContext(Consumer);

  useEffect(() => {
    if (!isRolesModule) {
      if (integrationPermission?.includes('write')) {
        setNewIntegration(true);
      }
    } else {
      if (allowedPermissions.includes('create_fb_integration')) {
        setNewIntegration(true);
      }
    }
  }, [isRolesModule, integrationPermission, allowedPermissions]);

  const history = useHistory()
  const getAllProjectFormIds = async () => {
    await getProjectFormIds(searchText).then((res) => {
      if (res.status === 200) {
        setProjectFormIDs(res.data.data);
      }
    });
  };

  const getApikey = async () => {
    await getAllApikeys().then((res) => {
      if (res.status === 200) {
        setApiKey(res.data?.data?.apikey);
      }
    });
  };

  const inactiveProjectFormId = async (uuid) => {
    await deleteProjectFormId(uuid).then((res) => {
      if (res.status === 200) {
        getAllProjectFormIds()
        toast.success(res.data.message);
      }
    });
  };

  const getUsersAuthRolePermissions = () => {
    getAuthRolePermissions().then((res) => {
      res.data.data.map((role) => {
        if (role.module === "integration") {
          setIntegrationPermission(role.permissions)
        }
      })
    })
  }

  const updateIntergratedLead = useCallback((lead) => {
    setSelectedIntegration(lead)
  }, [])

  const showEditLead = useCallback(() => {
    setConnectFacebookForm(true);
  }, [])

  const clearSelectedIntegration = useCallback(() => {
    setSelectedIntegration('')
  }, [])


  const closeFbModal = useCallback(() => {
    setShowFbModal(false)
  }, []);

  useEffect(() => {
    getAllProjectFormIds();
    getApikey();
    getUsersAuthRolePermissions();
  }, []);

  useEffect(() => {
    getAllProjectFormIds();
  }, [searchText])

  const handelClearSearch = useCallback(() => {
    setSearchText('')
  }, []);

  return (
    <>
      {showConnectFacebookForm &&
        <ConnectFacebookFormModal
          showConnectFacebookForm={showConnectFacebookForm}
          setConnectFacebookForm={setConnectFacebookForm}
          getAllProjectFormIds={getAllProjectFormIds}
          apiKey={apiKey}
          getApikey={getApikey}
          selectedIntegration={selectedIntegration}
          clearSelectedIntegration={clearSelectedIntegration}
        />
      }
      <div className="w-100 flex flex-col h-full">
        <div className="settings-title facebook-head">
          <div className="row d-flex flex-fill">
            <div className="col-xl-7 col-lg-6 d-flex flex-fill flex-column">
              <h1 className="fz24 mb-16 black fw-po-medium flex items-center gap-x-2">
                <Link

                  to='/settings/integrations/all-integrations'
                  className="w-8 h-8 hover:bg-black200 rounded inline-flex items-center justify-center titlebackbtn"
                >
                  <Pageback className="group-hover:stroke-black" />
                </Link>

                Facebook Ads
              </h1>
              <p className="fz16 black-dark-700 mb-0 !pl-10">
                Connect FB ads to Propacity Platform via make.com
              </p>
            </div>
            <div className="col-xl-5 col-lg-6 justify-content-md-end d-flex flex-fill align-items-end mt-nd-0 mt-3 pl-md-0">
              <div className={`form-group position-relative search-input ${searchText ? 'input-active' : ''} `}>
                <div className="serch-icon">
                  <img src={SearchIcon} className="" /></div>
                <input type="text" placeholder="Search" onChange={(e) => setSearchText(e.target.value)} className="searchinput" value={searchText} />
                {searchText &&
                  <div className="close-icon" onClick={handelClearSearch} style={{ top: '12px' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                      <path fillRule="evenodd" clipRule="evenodd" d="M5.94131 5.00019L9.45935 8.52142C9.71958 8.78188 9.71939 9.20399 9.45892 9.46423C9.19845 9.72446 8.77634 9.72427 8.51611 9.4638L4.9978 5.9423L1.47122 9.46365C1.21067 9.7238 0.788564 9.72349 0.528408 9.46295C0.268252 9.2024 0.268566 8.78029 0.529109 8.52014L4.05542 4.99907L0.53071 1.47117C0.270478 1.2107 0.270669 0.788594 0.531136 0.528362C0.791603 0.26813 1.21371 0.268321 1.47395 0.528788L4.99893 4.05696L8.51612 0.544989C8.77666 0.284833 9.19877 0.285147 9.45893 0.54569C9.71909 0.806233 9.71877 1.22834 9.45823 1.4885L5.94131 5.00019Z" fill="#696974" />
                    </svg>
                  </div>}
              </div>
              {newIntergrations &&

                <button
                  onClick={() => {
                    setConnectFacebookForm(!showConnectFacebookForm);
                    clearSelectedIntegration();
                  }}
                  className="pr-btn ml-12 px-16"
                >
                  <svg className="mr4 d-xl-inline d-none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><mask id="path-1-inside-1_1117_451" fill="white"><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z"></path></mask><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z" fill="white"></path><path d="M12.6665 11.3335H9.66653V14.3335H12.6665V11.3335ZM12.6665 12.6668V9.66678H9.66653V12.6668H12.6665ZM11.3332 12.6668H14.3332V9.66678H11.3332V12.6668ZM11.3332 11.3335V14.3335H14.3332V11.3335H11.3332ZM12.6665 14.3335H17.3331V8.33347H12.6665V14.3335ZM17.3331 14.3335C16.0444 14.3335 14.9998 13.2888 14.9998 12.0001H20.9998C20.9998 9.97509 19.3581 8.33347 17.3331 8.33347V14.3335ZM14.9998 12.0001C14.9998 10.7115 16.0444 9.66678 17.3331 9.66678V15.6668C19.3581 15.6668 20.9998 14.0252 20.9998 12.0001H14.9998ZM17.3331 9.66678H12.6665V15.6668H17.3331V9.66678ZM9.66653 12.6668V17.3333H15.6665V12.6668H9.66653ZM9.66653 17.3333C9.66653 16.0447 10.7112 15 11.9999 15V21C14.0249 21 15.6665 19.3584 15.6665 17.3333H9.66653ZM11.9999 15C13.2885 15 14.3332 16.0447 14.3332 17.3333H8.33322C8.33322 19.3584 9.97484 21 11.9999 21V15ZM14.3332 17.3333V12.6668H8.33322V17.3333H14.3332ZM11.3332 9.66678H6.66665V15.6668H11.3332V9.66678ZM6.66665 9.66678C7.95533 9.66678 9 10.7115 9 12.0001H3C3 14.0252 4.64162 15.6668 6.66665 15.6668V9.66678ZM9 12.0001C9 13.2888 7.95533 14.3335 6.66665 14.3335V8.33347C4.64162 8.33347 3 9.97509 3 12.0001H9ZM6.66665 14.3335H11.3332V8.33347H6.66665V14.3335ZM14.3332 11.3335V6.6669H8.33322V11.3335H14.3332ZM14.3332 6.6669C14.3332 7.95557 13.2885 9.00024 11.9999 9.00024V3.00024C9.97484 3.00024 8.33322 4.64186 8.33322 6.6669H14.3332ZM11.9999 9.00024C10.7112 9.00024 9.66653 7.95557 9.66653 6.6669H15.6665C15.6665 4.64186 14.0249 3.00024 11.9999 3.00024V9.00024ZM9.66653 6.6669V11.3335H15.6665V6.6669H9.66653Z" fill="white" mask="url(#path-1-inside-1_1117_451)"></path></svg>
                  <span className="ml-0 d-xl-inline d-none">New Integration</span>
                  <span className="ml-0 d-xl-none d-block px-16">Add New</span>
                </button>
              }
            </div>
          </div>
        </div>
        <div className="ml-24 mt-24 facbook-leads-add h-full flex flex-col overflow-auto">
          {projectFormIDs.length ? (
            <FacebookLeadAdsTable
              projectFormIDs={projectFormIDs}
              apiKey={apiKey}
              inactiveProjectFormId={(uuid) => inactiveProjectFormId(uuid)}
              integrationPermission={integrationPermission}
              updateIntergratedLead={updateIntergratedLead}
              showEditLead={showEditLead}
            />
          ) : (
            <DefaultFacebookLeadAds
              showConnectFacebookForm={showConnectFacebookForm}
              setConnectFacebookForm={setConnectFacebookForm}
              integrationPermission={integrationPermission}
              newIntergrations={newIntergrations}
            />
          )}
        </div>
      </div>
      {
        showFbModal && <FbIntegrationModal showFbModal={showFbModal} closeFbModal={closeFbModal} />
      }
      {
        showNewFBInfoModal && <SmallCenterModal show={showNewFBInfoModal} closeModal={() => setShowNewFBInfoModal(false)} dialogClassName={'unprocessed-leads PauseIntegrationModal'}>
          <div className=''>
            <div className="pr-0">
              <a onClick={() => setShowNewFBInfoModal(false)} className='cursor-pointer close'><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M13.4115 12.0003L18.6886 17.2822C19.079 17.6729 19.0787 18.306 18.688 18.6964C18.2973 19.0867 17.6641 19.0864 17.2738 18.6957L11.9963 13.4135L6.70658 18.6953C6.31577 19.0856 5.6826 19.0851 5.29237 18.6943C4.90213 18.3035 4.9026 17.6703 5.29342 17.2801L10.5827 11.9986L5.29565 6.70679C4.9053 6.31609 4.90559 5.68292 5.29629 5.29257C5.68699 4.90223 6.32016 4.90251 6.7105 5.29321L11.998 10.5855L17.2739 5.31734C17.6648 4.92711 18.2979 4.92758 18.6881 5.31839C19.0784 5.70921 19.0779 6.34237 18.6871 6.73261L13.4115 12.0003Z" fill="#171725"></path></svg></a>
            </div>
            <h1 className='fz20 fw-po-medium black mb-8 po'> New Update</h1>
            <p className="black-dark-700 fz14 ls2 ro mb-0">A better version of Facebook Integration is available with Propacity platform.</p>

            <div className='d-flex justify-content-end mt-24'>
              <button className='pr-btn px-24 py-6 fw-po-medium d-table ml-12 fz16 w-50' onClick={() => history.push('/settings/integrations/all-integrations/facebook-forms')} >Try Now</button>
            </div>
          </div>
        </ SmallCenterModal>
      }
    </>
  );
};

export default FacebookLeadAds;
